import { DASHBOARD_ROW_HEIGHT } from 'business/constants';
import { DashboardChartT, WidgetTypeT } from 'business/definitions';

/**
 * Get the number of rows that should be added to a chart in the grid layout
 * based on the number of comments that it has.
 */
function getNumberOfRows(commentsNumber: number): number {
    return Math.min((commentsNumber + 1) * 2, 8);
}

export function getHeightOfRows(commentsNumber: number): number {
    return getNumberOfRows(commentsNumber) * DASHBOARD_ROW_HEIGHT;
}

// FIXME: move these types in a more appropriate location
type LayoutItemT = {
    x: number;
    y: number;
    h: number;
    w: number;
};

export type Breakstyle = 'xs' | 'md';
type BreakstyleLayout = Record<Breakstyle, LayoutItemT>;

export type WidgetContent = {
    text?: string;
    tiptap?: string;
    url?: string;
    fontColor?: string;
    backgroundColor?: string;
    dashboardSlug?: string | null;
};
export type WidgetT = {
    position: BreakstyleLayout;
    type: WidgetTypeT;
    key: number;
    content?: WidgetContent;
    chart?: DashboardChartT;
    layoutId: number;
    // number of widget rows overflowing from current page (widget between 2 pages)
    // rows are defined as elements of the React Layout Engine, following 'md' breakstyle
    // always >= 0
    pageRowOverflow?: number;
};
